import { encryptBikData } from '../../utilities/encryption';

export interface IChannelInfo {
  channel: 'sms' | 'email' | 'whatsapp';
  value: string;
}
export interface IPayloadFetchCouponCode {
  storeId: string;
  widgetId: string;
  primaryInfo: IChannelInfo[];
  secondaryInfo: IChannelInfo[];
  templateId: string;
  quadrant?: number;
  session?: string;
  productId?: number;
  productName?: string;
  variantId?: number;
  variantName?: string;
  variantPrice?: number;
}
export const fetchCouponCode = async (
  payload: IPayloadFetchCouponCode,
  environment,
) => {
  const isStw =
    payload.templateId === 'KHnL25g05yRTFCGyJFit' ||
    payload.templateId === 'KcG3ONb3O8OPE2CSAXWJ';
  const url = `${environment}/publicApiFunctions-${isStw ? 'claimReward' : 'fetchCouponCode'}`;
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  });
  return response.json();
};

export const addLead = async (
  payload: IPayloadFetchCouponCode,
  environment,
) => {
  const response = await fetch(`${environment}/publicApiFunctions-addLead`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  });
  return response.json();
};

export const sendWidgetEvent = (event, widgetId, env) => {
  fetch(`${env}/publicApiFunctions-sendWidgetEvent`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      widgetId: widgetId,
      event,
    }),
  })
    .then(response => response.json())
    .then(() => {});
};
